import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AnzeigenDetailComponent } from './anzeigen-detail/anzeigen-detail.component';
import { AnzeigenListComponent } from './anzeigen-list/anzeigen-list.component';
import { AnzeigenKondolenzCreateComponent } from './anzeigen-kondolenz-create/anzeigen-kondolenz-create.component';
import {ConfirmComponent} from './confirm/confirm.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'anzeigen-list' },
  { path: 'anzeigen-list', component: AnzeigenListComponent,data: { state: 'home' }},
  { path: 'anzeigen-detail/:anzeigenId', component: AnzeigenDetailComponent,data: { state: 'detail' } },
  { path: 'anzeigen-kondolenz-create', component: AnzeigenKondolenzCreateComponent, data: { state: 'kondolenz' } },
  { path: 'confirm', component: ConfirmComponent,data: { state: 'confirm' } },
]

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
